import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { SessionService } from "./../session/session.service";
import { environment } from "../../../environments/environment";
import { PessoaService } from "./../pessoa/pessoa.service";
import { ProcessoSeletivo } from "./processo-seletivo";
import { HeaderService } from "./../http/header.service";

@Injectable()
export class ProcessoService {
  constructor(
    private http: Http,
    private SessionService: SessionService,
    private PessoaService: PessoaService,
    private HeaderService: HeaderService
  ) {}

  getProcessoSeletivoSelecionado() {
    const processo: any = this.getProcessoSeletivo();
    let PrcLetAno = this.getPrcLetAno();
    let PrcLetSem = this.getPrcLetSem();
    let PrcTipPrc = sessionStorage.getItem("PrcTipPrc");
    let TipoProcesso;
    if (processo) {
      if (PrcTipPrc == "G" || PrcTipPrc == null || typeof PrcTipPrc == "undefined"){
        processo.TipoProcesso.forEach((Tipo) => {
          if (Tipo.PrcTipCod == this.getTipoProcesso()) {
            TipoProcesso = Tipo;
          }
        });
      }else{
        processo.TipoProcesso.forEach((Tipo) => {
          if (Tipo.PrcTipCod == this.getTipoProcesso() && Tipo.PrcLetAno == PrcLetAno && Tipo.PrcLetSem == PrcLetSem) {
            TipoProcesso = Tipo;
          }
        });
      };
    }

    if (TipoProcesso) {
      return TipoProcesso;
    }

    return false;
  }

  getOcorrenciaSelecionada() {
    const processo = this.getProcessoSeletivoSelecionado();

    if (!processo) {
      return null;
    }

    let ocorrencia = null;

    processo.Ocorrencia.some((o) => {
      if (o.PrcOcoSeq == this.getOcorrencia()) {
        ocorrencia = o;
        return true;
      }

      return false;
    });

    return ocorrencia;
  }

  getMatriculaRedirecionamento() {
    const processo: any = this.getProcessoSeletivoSelecionado();

    let PrcGerCha: boolean = false;

    if (processo) {
      processo.Ocorrencia.forEach((ocorrencia) => {
        if (
          this.getTipoProcesso() == processo.PrcTipCod &&
          ocorrencia.PrcOcoSeq == this.getOcorrencia()
        ) {
          PrcGerCha = ocorrencia.PrcGerCha;
        }
      });
    }

    if (PrcGerCha) {
      return PrcGerCha;
    }

    return false;
  }

  checkAbrirPaginaEnsinoMedio() {
    const processo: any = this.getProcessoSeletivoSelecionado();

    let PrcSolEnsMed: boolean = false;

    if (processo) {
      processo.Ocorrencia.forEach((ocorrencia) => {
        if (
          this.getTipoProcesso() == processo.PrcTipCod &&
          ocorrencia.PrcOcoSeq == this.getOcorrencia()
        ) {
          PrcSolEnsMed = ocorrencia.PrcSolEnsMed;
        }
      });
    }

    if (PrcSolEnsMed) {
      return PrcSolEnsMed;
    }

    return false;
  }

  checkAbrirPaginaDocumentos() {
    const processo: any = this.getProcessoSeletivoSelecionado();

    let PrcSolDocs: boolean = false;

    if (processo) {
      processo.Ocorrencia.forEach((ocorrencia) => {
        if (
          this.getTipoProcesso() == processo.PrcTipCod &&
          ocorrencia.PrcOcoSeq == this.getOcorrencia()
        ) {
          PrcSolDocs = ocorrencia.PrcSolDocs;
        }
      });
    }

    if (PrcSolDocs) {
      return PrcSolDocs;
    }

    return false;
  }

  getNomeProcesso() {
    const processo: any = this.getProcessoSeletivoSelecionado();

    let PrcNom: string;

    if (processo) {
      processo.Ocorrencia.forEach((ocorrencia) => {
        if (
          this.getTipoProcesso() == processo.PrcTipCod &&
          ocorrencia.PrcOcoSeq == this.getOcorrencia()
        ) {
          PrcNom = ocorrencia.PrcNom;
        }
      });
    }

    if (PrcNom) {
      return PrcNom;
    }

    return "";
  }

  getOcorrencia() {
    return JSON.parse(this.SessionService.getValor("ocorrencia"));
  }

  setOcorrencia(ocorrencia) {
    this.SessionService.setValor("ocorrencia", ocorrencia);
  }

  getTipoProcesso() {
    return JSON.parse(this.SessionService.getValor("tipo_processo"));
  }

  setTipoProcesso(tipo) {
    this.SessionService.setValor("tipo_processo", tipo);
  }

  fichaInscricao() {
    const headers = this.HeaderService.getHeadersGnx();
    const candidato = JSON.parse(this.SessionService.getValor("candidato"));
    const curso = JSON.parse(this.SessionService.getValor("cursoSelecionado"));
    const processo = this.getProcessoSeletivoSelecionado();

    if (headers && candidato) {
      return this.http
        .post(
          environment.apiGxUrl + "/wsprcfichainscricao.svc/rest/",
          {
            PrcCdtCod: candidato.PrcCdtCod,
            PrcLetAno: processo.PrcLetAno,
            PrcLetSem: processo.PrcLetSem,
            PrcTipCod: this.getTipoProcesso(),
            PrcOcoSeq: curso.PrcOcoSeq,
            PrcOfeSeq: curso.PrcOfeSeq,
          },
          { headers: headers }
        )
        .map((res) => res.json())
        .catch((err: any) => {
          return Observable.throw(new Error(err.json()));
        });
    }
  }

  credenciaBolda() {
    const headers = this.HeaderService.getHeadersGnx();
    if (headers) {
      return this.http
        .get(environment.apiGxUrl + "/wsprcreqbolsa.svc/rest/", { headers: headers })
        .map((res) => res.json())
        .catch((err: any) => {
          return Observable.throw(err.json());
        });
    }
  }

  validaRegrasBolsa(params) {
    const headers = this.HeaderService.getHeadersGnx();

    const processo = this.getProcessoSeletivoSelecionado();

    const body = {
      PrcLetAno: processo.PrcLetAno,
      PrcLetSem: processo.PrcLetSem,
      PrcTipCod: processo.PrcTipCod,
      PrcOcoSeq: this.getOcorrencia(),
      ...params,
    };

    return this.http
      .post(`${environment.apiGxUrl}/wsprcvalidaregras.svc/rest/`, body, { headers })
      .map((response) => response.json())
      .catch((error) => Observable.throw(error.json()));
  }

  validaListaEspera() {
    const headers = this.HeaderService.getHeadersGnx();

    const processo = this.getProcessoSeletivoSelecionado();
    const cursoSelecionado = JSON.parse(
      this.SessionService.getValor("cursoSelecionado")
    );

    const body = {
      PrcLetAno: processo.PrcLetAno,
      PrcLetSem: processo.PrcLetSem,
      PrcTipCod: processo.PrcTipCod,
      PrcOcoSeq: this.getOcorrencia(),
      PrcOfeSeq: cursoSelecionado.PrcOfeSeq,
    };
    return this.http
      .post(`${environment.apiGxUrl}/wsprcvalidalistaespera.svc/rest/`, body, { headers })
      .map((response) => response.json())
      .catch((error) => Observable.throw(error.json()));
  }

  excluirListaEspera() {
    const headers = this.HeaderService.getHeadersGnx();

    const processo = this.getProcessoSeletivoSelecionado();
    const cursoSelecionado = JSON.parse(
      this.SessionService.getValor("cursoSelecionado")
    );

    const body = {
      PrcLetAno: processo.PrcLetAno,
      PrcLetSem: processo.PrcLetSem,
      PrcTipCod: processo.PrcTipCod,
      PrcOcoSeq: this.getOcorrencia(),
      PrcOfeSeq: cursoSelecionado.PrcOfeSeq,
    };

    return this.http
      .post(`${environment.apiGxUrl}/wsprcexcluilistaespera.svc/rest/`, body, { headers })
      .map((response) => response.json())
      .catch((error) => Observable.throw(error.json()));
  }

  enviaEmail() {
    const headers = this.HeaderService.getHeadersGnx();
    const candidato = JSON.parse(this.SessionService.getValor("candidato"));
    if (headers && candidato) {
      return this.http
        .post(
          environment.apiGxUrl + "/wspsgrvfilaemail.svc/rest/",
          {
            PrcCdtCod: candidato.PrcCdtCod,
            PrcTipCod: this.getTipoProcesso(),
          },
          { headers: headers }
        )
        .map((res) => res.json())
        .catch((err: any) => {
          return Observable.throw(new Error(err.json()));
        });
    }
  }

  enviaLogMatricula() {
    const headers = this.HeaderService.getHeadersGnx();

    const cursoSelecionado = JSON.parse(
      this.SessionService.getValor("cursoSelecionado")
    );

    const candidato = JSON.parse(this.SessionService.getValor("candidato"));
    if (headers && candidato) {
      return this.http
        .post(
          environment.apiGxUrl + "/wsgravalogprospect.svc/rest/",
          {
            sdtpadrao: [
              { Codigo: 379, Descricao: cursoSelecionado.PrcOfeCurCod },
            ],
          },
          { headers: headers }
        )
        .map((res) => res.json())
        .catch((err: any) => {
          return Observable.throw(new Error(err.json()));
        });
    }
  }

  setProcessoSeletivo(processo) {
    this.SessionService.setValor("processoSeletivo", JSON.stringify(processo));
  }

  getProcessoSeletivo() {
    return JSON.parse(this.SessionService.getValor("processoSeletivo"));
  }

  getEnsinoMedio(): Observable<any> {
    const headers = this.HeaderService.getHeadersGnx();
    const pessoa = this.PessoaService.getPessoa();

    if (headers && pessoa) {
      return this.http
        .post(
          environment.apiGxUrl + "/wsprccandidato.svc/rest/",
          { PrcCdtPesCod: pessoa.pes_cod_comp },
          { headers: headers }
        )
        .map((res: Response) => res.json())
        .catch((err: any) => {
          return Observable.throw(new Error(err.json()));
        });
    }
  }

  getConcluinte(): Observable<any> {
    const headers = this.HeaderService.getHeadersGnx();

    const processo = this.getProcessoSeletivoSelecionado();

    const body = {
      PrcLetAno: processo.PrcLetAno,
      PrcLetSem: processo.PrcLetSem,
      PrcTipCod: processo.PrcTipCod,
      PrcOcoSeq: this.getOcorrencia(),
    };

    return this.http
      .post(environment.apiGxUrl + "/wsprcmsgconcluinte.svc/rest/", body, { headers })
      .map((res: Response) => res.json());
  }

  getProcessos() {
    const processo = JSON.parse(
      this.SessionService.getValor("processoSeletivo")
    );

    if (processo) {
      return processo.Processos;
    }

    return null;
  }

  setPrcLetAno(PrcLetAno){
    this.SessionService.setValor("PrcLetAno", PrcLetAno);
  }

  setPrcLetSem(PrcLetSem){
    this.SessionService.setValor("PrcLetSem", PrcLetSem);
  }

  getPrcLetAno(){
    const PrcLetAno = this.SessionService.getValor("PrcLetAno");
    return PrcLetAno;
  }

  getPrcLetSem(){
    const PrcLetSem = this.SessionService.getValor("PrcLetSem");
    return PrcLetSem;
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/processo/processo.service.ts